import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { LiaisonEntite } from '../entites/liaison';
import { MessageService } from 'primeng/api';
import { BaseService } from './base.service';

@Injectable({ providedIn: 'root' })
export class LiaisonService extends BaseService {

  private ajouterUrl = environment.apiBaseUrl + 'liaison';
  private supprimerUrl = environment.apiBaseUrl + 'liaison/supprimer';


  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private http: HttpClient,
    public messageService: MessageService,
    public router: Router) { 
      super(messageService, router);
    }

  public Ajouter(liaison: LiaisonEntite): Observable<ReponseBase<LiaisonEntite>> {
    return this.http.post<ReponseBase<LiaisonEntite>>(this.ajouterUrl, JSON.stringify(liaison), this.httpOptions)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }


  public Supprimer(liaison: LiaisonEntite): Promise<ReponseBase<number>> {
    var p = this.http.post<ReponseBase<number>>(this.supprimerUrl, JSON.stringify(liaison), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }
}
